import type { AppLanguage } from '@/shared/Types/config.types.ts'

export const FALLBACK_LANGUAGE: AppLanguage = 'de'

export const LANGUAGE_STORAGE_KEY = 'app-language'

export const AVAILABLE_LANGUAGES = [
    'de',
    'en',
] as const satisfies ReadonlyArray<AppLanguage>

export const LANGUAGE_RESOURCE_LOADERS: Record<
    AppLanguage,
    () => Promise<unknown>
> = {
    de: () => import('@/language/Locales/de.json'),
    en: () => import('@/language/Locales/en.json'),
}

export const FLAG_IMAGES: Record<AppLanguage, string> = {
    de: '/images/flags/de.webp',
    en: '/images/flags/en.webp',
}
